'use client';

import { cn } from '@whitbread-eos/utils';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis, Cell } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '../Chart/chart';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FinancialChart(_ref) {
  var chartData = _ref.chartData,
    chartConfig = _ref.chartConfig,
    axisDataKey = _ref.axisDataKey,
    dataTestId = _ref.dataTestId,
    className = _ref.className,
    tooltipNameKey = _ref.tooltipNameKey,
    barDataKey = _ref.barDataKey,
    _ref$tooltipPosition = _ref.tooltipPosition,
    tooltipPosition = _ref$tooltipPosition === void 0 ? {
      x: 0,
      y: 0
    } : _ref$tooltipPosition,
    _ref$activeIndex = _ref.activeIndex,
    activeIndex = _ref$activeIndex === void 0 ? null : _ref$activeIndex,
    _ref$showTooltip = _ref.showTooltip,
    showTooltip = _ref$showTooltip === void 0 ? false : _ref$showTooltip,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    formatXAxis = _ref.formatXAxis,
    formatYAxis = _ref.formatYAxis,
    formatTooltip = _ref.formatTooltip,
    formatLabel = _ref.formatLabel,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  return _jsx(ChartContainer, {
    config: chartConfig,
    className: cn(className, 'relative h-[14.375rem] w-full', disabled ? 'opacity-[30%]' : '', disabled ? 'disabled' : ''),
    "data-testid": "".concat(dataTestId, "-recharts-container"),
    children: _jsxs(BarChart, {
      accessibilityLayer: true,
      data: chartData,
      barSize: 38.83,
      overflow: 'visible',
      children: [_jsx(CartesianGrid, {
        horizontal: true,
        vertical: false
      }), _jsx(XAxis, {
        dataKey: axisDataKey,
        tick: {
          fill: 'var(--dark-grey-1)',
          opacity: activeIndex !== null ? 0.5 : 1
        },
        tickLine: false,
        tickMargin: 10,
        axisLine: false,
        tickFormatter: formatXAxis
      }), _jsx(YAxis, {
        type: "number",
        axisLine: false,
        tick: {
          fill: 'var(--dark-grey-1)',
          width: 250
        },
        tickFormatter: formatYAxis,
        tickLine: false,
        tickCount: 6,
        interval: 0
      }), _jsx(ChartTooltip, {
        active: showTooltip,
        labelClassName: "recharts-tooltip-label",
        position: {
          x: tooltipPosition === null || tooltipPosition === void 0 ? void 0 : tooltipPosition.x,
          y: tooltipPosition === null || tooltipPosition === void 0 ? void 0 : tooltipPosition.y
        },
        content: _jsx(ChartTooltipContent, {
          className: "text-[.875rem] leading-[1.25rem] min-w-[9.68rem] min-h-[4.87rem] rounded-sm px-[1rem] py-[.5rem] bg-[var(--tooltipInfo)]",
          nameKey: tooltipNameKey,
          formatter: formatTooltip,
          labelFormatter: formatLabel
        })
      }), _jsx(Bar, {
        dataKey: barDataKey,
        onMouseEnter: !disabled ? onMouseEnter : undefined,
        onMouseLeave: !disabled ? onMouseLeave : undefined,
        fill: disabled ? 'var(--dark-grey-2)' : 'var(--primaryColor)',
        children: chartData === null || chartData === void 0 ? void 0 : chartData.map((entry, index) => {
          var activeCellClass = activeIndex === null ? '' : activeIndex === index ? 'active-chart-cell' : 'inactive-chart-cell';
          var lastCellClass = index === (chartData === null || chartData === void 0 ? void 0 : chartData.length) - 1 ? ' last-chart-cell' : '';
          return _jsx(Cell, {
            cursor: !disabled ? 'pointer' : 'default',
            className: "chart-cell ".concat(activeCellClass).concat(lastCellClass),
            fill: disabled ? 'var(--dark-grey-2)' : 'var(--primaryColor)'
          }, "cell-".concat(index));
        })
      })]
    })
  });
}